import { render } from "./quotation_remark.vue?vue&type=template&id=4f69fe1e"
import script from "./quotation_remark.vue?vue&type=script&lang=js"
export * from "./quotation_remark.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__